import {
    deleteRouteInvoiceLoading,
    deleteRouteInvoiceRequest,
    deleteRouteInvoiceSuccess,
    deleteRouteInvoiceReject,
    deleteRouteInvoiceReset
} from "../../actions/invoiceProvider/deleteRouteInvoice";

export const deleteRouteInvoice = (formData) => async (dispatch, getState) => {
    try {
        dispatch(deleteRouteInvoiceLoading());
        const { data } = await deleteRouteInvoiceRequest(formData, getState);
        dispatch(deleteRouteInvoiceSuccess(data))
    } catch (error) {
        dispatch(deleteRouteInvoiceReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteRouteInvoiceReset()) }, 3000);
    }
    return Promise.resolve();
};